module.exports = __webpack_public_path__ + "static/media/signin-bg.94b90687.jpg";